import React from 'react';
import { ReleaseFilter } from '@/layout/common-filter/filters/ReleaseFilter';
import { addReleaseFilters, clearReleaseFilters } from './releaseCalendarSlice';

const filterActions = { addReleaseFilters, clearReleaseFilters };

export const ReleaseCalendarFilter = () => (
  <ReleaseFilter page="RELEASE_CALENDAR_PAGE" filterActions={filterActions} />
);
